/* JFF: カート（購入手続きの手前）
   1) 「あと◯円で国内送料無料」メーター
   2) 送料無料ラインにちょうど届く金額の商品を2つ（その場でカートに追加できる）
   3) 金額に関係なく、関連商品を2つ「こちらもオススメ👀」 */
(function () {
  var FREE_LINE = 20000;            // 送料無料ライン（円・税込・商品小計）
  var POOL = ['アパレル', '小物-アクセサリー']; // 「ちょうどいい金額」の候補を探すコレクション
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var recCache = {};
  var pool = null;
  var busy = false, queued = false, lastKey = '';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function yen(n) { return '¥' + Math.round(n).toLocaleString('ja-JP'); }
  function imgUrl(src) {
    if (!src) return '';
    if (typeof src === 'object') src = src.src || '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=300';
  }

  /* 表示場所：横から出るカート と カートページ */
  function places() {
    var list = [];
    var wrap = document.querySelector('#CartDrawer-CartItems .drawer__cart-items-wrapper');
    if (wrap) list.push({ kind: 'drawer', top: wrap, bottom: wrap });
    var page = document.querySelector('#main-cart-footer:not(.is-empty) .cart__blocks');
    var items = document.querySelector('#main-cart-items .cart__items, cart-items .cart__items');
    if (page) list.push({ kind: 'page', top: items || page, bottom: page, pageBlocks: page });
    return list;
  }

  /* 候補（アパレル・小物）を一度だけ取得：1商品＝在庫のある一番安いバリエーションの価格 */
  async function getPool() {
    if (pool) return pool;
    var seen = {}, out = [];
    for (var i = 0; i < POOL.length; i++) {
      for (var page = 1; page <= 2; page++) {
        try {
          var r = await fetch(root + 'collections/' + encodeURIComponent(POOL[i]) + '/products.json?limit=250&page=' + page);
          if (!r.ok) break;
          var j = await r.json();
          var ps = j.products || [];
          ps.forEach(function (p) {
            if (seen[p.id]) return;
            var vs = (p.variants || []).filter(function (v) { return v.available; });
            if (!vs.length) return;
            seen[p.id] = 1;
            var min = Math.min.apply(null, vs.map(function (v) { return parseFloat(v.price); }));
            if (!(min > 0)) return;
            out.push({
              id: p.id, title: p.title, url: root + 'products/' + p.handle,
              image: p.images && p.images[0] ? p.images[0].src : '',
              price: min,
              variants: vs.map(function (v) { return { id: v.id, title: v.title, price: parseFloat(v.price) }; })
            });
          });
          if (ps.length < 250) break;
        } catch (e) { break; }
      }
    }
    pool = out;
    return pool;
  }

  /* 残り金額にいちばん近い「届く」商品を2つ。足りなければ一番近い価格のもので補う */
  function pickFit(list, remain, exclude) {
    var cand = list.filter(function (p) { return exclude.indexOf(p.id) === -1; });
    var reach = cand.filter(function (p) { return p.price >= remain; })
      .sort(function (a, b) { return a.price - b.price; });
    var picks = reach.slice(0, 2);
    if (picks.length < 2) {
      var under = cand.filter(function (p) { return p.price < remain; })
        .sort(function (a, b) { return b.price - a.price; });
      picks = picks.concat(under.slice(0, 2 - picks.length));
    }
    return picks;
  }

  async function getRelated(productId) {
    if (recCache[productId]) return recCache[productId];
    try {
      var r = await fetch(root + 'recommendations/products.json?product_id=' + productId + '&limit=10&intent=related');
      var j = await r.json();
      recCache[productId] = j.products || [];
    } catch (e) { recCache[productId] = []; }
    return recCache[productId];
  }

  function meterHTML(sub) {
    var remain = FREE_LINE - sub;
    var pct = Math.max(0, Math.min(100, (sub / FREE_LINE) * 100));
    var msg = remain > 0
      ? 'あと <b>' + yen(remain) + '</b> で国内送料無料！'
      : '<b>国内送料無料</b>になりました 🎉';
    return '<p class="jff-ship__msg">' + msg + '</p>' +
      '<div class="jff-ship__bar" role="progressbar" aria-valuemin="0" aria-valuemax="' + FREE_LINE +
      '" aria-valuenow="' + Math.min(sub, FREE_LINE) + '"><span style="width:' + pct.toFixed(1) + '%"></span></div>';
  }

  function fitCard(p, remain) {
    var hit = p.price >= remain;
    var sel = '';
    if (p.variants.length > 1) {
      sel = '<select class="jff-fit__variant" aria-label="サイズ・種類を選ぶ">' +
        p.variants.map(function (v) {
          return '<option value="' + v.id + '">' + esc(v.title) + (v.price !== p.price ? '（' + yen(v.price) + '）' : '') + '</option>';
        }).join('') + '</select>';
    }
    return '<div class="jff-fit__item" data-variant="' + p.variants[0].id + '">' +
      '<a class="jff-cart-recs__img" href="' + esc(p.url) + '"><img src="' + esc(imgUrl(p.image)) + '" alt="" loading="lazy"></a>' +
      '<a class="jff-cart-recs__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
      '<span class="jff-cart-recs__price"><b>' + yen(p.price) + '</b>' +
      (hit ? '<span class="jff-fit__tag">これで送料無料</span>' : '') + '</span>' +
      sel +
      '<button type="button" class="jff-fit__add">カートに追加</button>' +
      '</div>';
  }

  function relCard(p) {
    var sale = p.compare_at_price && p.compare_at_price > p.price;
    return '<a class="jff-cart-recs__item" href="' + esc(p.url) + '">' +
      '<span class="jff-cart-recs__img"><img src="' + esc(imgUrl(p.featured_image)) + '" alt="" loading="lazy"></span>' +
      '<span class="jff-cart-recs__name">' + esc(p.title) + '</span>' +
      '<span class="jff-cart-recs__price">' +
      (sale ? '<s>' + yen(p.compare_at_price / 100) + '</s> ' : '') +
      '<b' + (sale ? ' class="is-sale"' : '') + '>' + yen(p.price / 100) + '</b></span></a>';
  }

  function clearOld() {
    document.querySelectorAll('.jff-ship, .jff-cart-recs').forEach(function (n) { n.remove(); });
  }

  async function run() {
    if (busy) { queued = true; return; }
    var ps = places();
    if (!ps.length) return;
    busy = true;
    try {
      var cart = await (await fetch(root + 'cart.js')).json();
      var key = ps.map(function (p) { return p.kind; }).join() + '|' + cart.item_count + '|' + cart.items_subtotal_price;
      var present = ps.every(function (p) { return p.top.parentNode && p.top.parentNode.querySelector(':scope > .jff-ship'); });
      if (key === lastKey && present) return;
      if (!cart.items || !cart.items.length) { clearOld(); lastKey = key; return; }

      var sub = cart.items_subtotal_price / 100;   // 円
      var remain = FREE_LINE - sub;
      var inCart = cart.items.map(function (i) { return i.product_id; });

      var fit = [];
      if (remain > 0) fit = pickFit(await getPool(), remain, inCart);
      var fitIds = fit.map(function (p) { return p.id; });

      var rel = (await getRelated(cart.items[0].product_id)).filter(function (p) {
        return p.available && inCart.indexOf(p.id) === -1 && fitIds.indexOf(p.id) === -1;
      }).slice(0, 2);

      clearOld();
      ps.forEach(function (pl) {
        var m = document.createElement('div');
        m.className = 'jff-ship jff-ship--' + pl.kind;
        m.innerHTML = meterHTML(sub);
        pl.top.insertAdjacentElement('beforebegin', m);

        if (!fit.length && !rel.length) return;
        var box = document.createElement('div');
        box.className = 'jff-cart-recs jff-cart-recs--' + pl.kind;
        var html = '';
        if (fit.length) {
          var reachOne = fit.some(function (p) { return p.price >= remain; });
          html += '<p class="jff-cart-recs__title">' + (reachOne
            ? 'あと' + yen(remain) + '！1点足すだけで送料無料'
            : '送料無料まであと' + yen(remain) + '。合わせ買いにおすすめ') + '</p>' +
            '<div class="jff-cart-recs__list">' + fit.map(function (p) { return fitCard(p, remain); }).join('') + '</div>';
        }
        if (rel.length) {
          html += '<p class="jff-cart-recs__title' + (fit.length ? ' jff-cart-recs__title--2' : '') + '">こちらもオススメ👀</p>' +
            '<div class="jff-cart-recs__list">' + rel.map(relCard).join('') + '</div>';
        }
        box.innerHTML = html;
        if (pl.kind === 'drawer') pl.bottom.insertAdjacentElement('afterend', box);
        else pl.pageBlocks.insertBefore(box, pl.pageBlocks.firstElementChild);
      });
      lastKey = key;
    } catch (e) {
      /* 取得できない場合は何も表示しない */
    } finally {
      busy = false;
      if (queued) { queued = false; setTimeout(run, 50); }
    }
  }

  /* 「カートに追加」：横のカートはその場で更新、カートページは再読み込み */
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest && e.target.closest('.jff-fit__add');
    if (!btn) return;
    e.preventDefault();
    var item = btn.closest('.jff-fit__item');
    var sel = item.querySelector('.jff-fit__variant');
    var id = sel ? sel.value : item.getAttribute('data-variant');
    btn.disabled = true; btn.textContent = '追加中…';
    var drawer = document.querySelector('cart-drawer');
    var inDrawer = !!btn.closest('cart-drawer');
    try {
      var body = { items: [{ id: Number(id), quantity: 1 }] };
      if (inDrawer && drawer && drawer.renderContents) {
        body.sections = 'cart-drawer,cart-icon-bubble';
        body.sections_url = window.location.pathname;
      }
      var r = await fetch(root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      var j = await r.json();
      if (!r.ok) throw new Error(j.description || 'error');
      lastKey = '';
      if (inDrawer && drawer && drawer.renderContents && j.sections) {
        drawer.renderContents({ id: Number(id), sections: j.sections });
        schedule();
      } else {
        window.location.reload();
      }
    } catch (err) {
      btn.disabled = false; btn.textContent = '追加できませんでした';
      setTimeout(function () { btn.textContent = 'カートに追加'; }, 2500);
    }
  });

  var timer;
  function schedule() { clearTimeout(timer); timer = setTimeout(run, 150); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (t.closest && (t.closest('.jff-cart-recs') || t.closest('.jff-ship'))) continue;
      schedule();
      return;
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
